// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/CounterBadge/CounterBadge.less
// module id = 1399
// module chunks = 0